/* ==========================================================================
   NeoDocs — theme-owned Meta pixel events
   Datasets 1013316447147395 (original, restricted) + 1113883751093912 (new,
   health & wellness category) — dual-sending until cutover. ONE OWNER PER
   EVENT — never fire an event here that another sender already owns.

   Meta's health & wellness data restriction (active on this dataset since
   2026-09-30) silently discards the standard commerce events (AddToCart,
   InitiateCheckout, AddPaymentInfo, Purchase). All conversion-path events
   therefore use NEUTRAL custom names (NeoJourney... / Neo...), carry numeric
   ids only, and never include product names or health terms.
   (Never write a star followed by a slash in this comment — it ends the
   comment block and breaks the whole file.)

   OWNERSHIP MAP (updated 2026-10-13):

     Facebook & Instagram channel web pixel (id 926220592, Shopify-managed,
     runtimeContext OPEN — it runs on this window and reuses the fbq from
     theme.liquid, so its browser events reach BOTH datasets; its CAPI
     copies go only to 1013316447147395)
       PageView, ViewContent, Search (AddToCart subscription exists but the
       Buy Now flow bypasses the cart, and Meta blocks it anyway)
       content_ids = [parseInt(product.id)], content_type = 'product_group'

     checkout.neodocs.in iframe (app/checkout + /cart + /order-status)
       PageView (fired only when a page is genuinely shown — the hidden
       preload iframe no longer counts), NeoJourneyIntent, NeoJourneyStep2,
       NeoJourneyStep3, NeoJourneyStep4, NeoJourneyLogin, NeoJourneyStart
       (+ standard InitiateCheckout/Purchase only if the checkout app's
       SEND_STANDARD_META_EVENTS flag is re-enabled after a successful
       Meta appeal)

     THIS FILE — storefront engagement events nothing else fires
       ViewCategory (custom), NeoQuizComplete, NeoNewsletterJoin,
       NeoContactClick + advanced-matching re-init for logged-in customers
       NOTE (13 Oct 2026): ViewCategory, NeoNewsletterJoin and
       NeoContactClick are marked "unverified" in Events Manager on BOTH
       datasets, so fbevents.js suppresses them in the browser ("You are
       attempting to send an unverified event"). Verify them in Events
       Manager — renaming them here is not the fix.

   The old checkout-message listener (AddPaymentInfo / CompleteRegistration)
   is GONE: the checkout iframe now fires NeoJourneyStep4 / NeoJourneyLogin
   itself. Do not re-add a listener here — it would double-fire the funnel.
   ========================================================================== */

(function () {
  'use strict';

  var ctxEl = document.getElementById('neodocs-meta-context');
  var CTX = {};
  try {
    CTX = ctxEl ? JSON.parse(ctxEl.textContent) : {};
  } catch (e) {
    CTX = {};
  }

  // Dual-send targets. trackCustom() below broadcasts to every pixel the base
  // code in theme.liquid initialised, so this list is only needed for the
  // advanced-matching re-init. Keep it in step with theme.liquid.
  var PIXEL_IDS = CTX.pixelIds || ['1013316447147395', '1113883751093912'];

  /* --- consent ------------------------------------------------------------
     Marketing events are gated on Shopify's Customer Privacy API where it is
     present. If the API has not loaded we allow the event: this shop serves
     India, which is not a consent-gated region, and the channel pixel is
     configured with MARKETING purposes already granted. */
  function marketingAllowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.marketingAllowed !== 'function') return true;
      return api.marketingAllowed();
    } catch (e) {
      return true;
    }
  }

  /** Every call funnels through here: an ad blocker must never break a page. */
  function trackCustom(eventName, params) {
    try {
      if (typeof window.fbq !== 'function') return false;
      if (!marketingAllowed()) return false;
      window.fbq('trackCustom', eventName, params || {});
      return true;
    } catch (e) {
      return false;
    }
  }

  /* --- advanced matching --------------------------------------------------
     Only for a logged-in customer, and only values Shopify already gave us.
     fbq hashes these in the browser; nothing is logged or sent anywhere else. */
  function applyAdvancedMatching() {
    var c = CTX.customer;
    if (!c || typeof window.fbq !== 'function' || !marketingAllowed()) return;

    var am = {};
    if (c.em) am.em = String(c.em).trim().toLowerCase();
    if (c.ph) am.ph = String(c.ph).replace(/[^\d+]/g, '');
    if (c.fn) am.fn = String(c.fn).trim().toLowerCase();
    if (c.ln) am.ln = String(c.ln).trim().toLowerCase();
    if (c.ct) am.ct = String(c.ct).trim().toLowerCase().replace(/\s+/g, '');
    if (c.zp) am.zp = String(c.zp).trim();
    if (!Object.keys(am).length) return;

    am.country = 'in';
    // Re-initialising a pixel with matching data updates that data; it does
    // not emit an event, so this cannot duplicate anything.
    PIXEL_IDS.forEach(function (id) {
      try {
        window.fbq('init', id, am);
      } catch (e) {
        /* matching is a bonus, never a hard failure */
      }
    });
  }

  /* --- ViewCategory (custom) — collection pages ---------------------------
     content_ids only — numeric Shopify product ids, same shape as the channel
     pixel. Collection title/handle are NOT sent: for a health store they are
     exactly the terms Meta's policy screens for. */
  function viewCategory() {
    var c = CTX.collection;
    if (!c) return;
    var ids = (c.productIds || []).slice(0, 10).map(function (id) {
      var n = parseInt(id, 10);
      return isNaN(n) ? String(id) : n;
    });
    trackCustom('ViewCategory', {
      content_type: 'product_group',
      content_ids: ids,
      num_items: ids.length
    });
  }

  /* --- NeoQuizComplete: fertility quiz completion (was Lead) ---------------
     The submit button validates first, so a click alone is not a completion.
     Check on the next frame whether the result panel actually opened. */
  function bindQuiz() {
    var submit = document.getElementById('quiz-submit');
    var result = document.getElementById('quiz-result');
    if (!submit || !result) return;

    var fired = false;
    submit.addEventListener('click', function () {
      window.setTimeout(function () {
        if (fired) return;
        var shown = result.style.display !== 'none' && result.offsetParent !== null;
        if (!shown) return; // validation blocked it
        fired = true;
        trackCustom('NeoQuizComplete', {
          content_category: 'quiz'
        });
      }, 0);
    });
  }

  /* --- NeoNewsletterJoin: newsletter signup (was Subscribe) ---------------- */
  var newsletterFired = false;
  function bindNewsletter() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('neo-newsletter-form')) return;
      if (newsletterFired) return;
      newsletterFired = true;
      trackCustom('NeoNewsletterJoin', {
        content_category: 'newsletter'
      });
    }, true);
  }

  /* --- NeoContactClick: WhatsApp and phone (was Contact) ------------------- */
  function bindContact() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var channel = null;

      if (/^(https?:)?\/\/(api\.)?(wa\.me|whatsapp\.com|web\.whatsapp\.com)/i.test(href)) channel = 'whatsapp';
      else if (/^tel:/i.test(href)) channel = 'phone';
      if (!channel) return;

      trackCustom('NeoContactClick', {
        content_category: channel
      });
    }, true);
  }

  /* --- init ---------------------------------------------------------------- */
  function init() {
    applyAdvancedMatching();
    if (CTX.template === 'collection') viewCategory();
    bindQuiz();
    bindNewsletter();
    bindContact();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
